/** Open sign-up means every limit below is a cost control, not a product decision. */
export const QUOTAS = {
    appsPerBuilder: 3,
    deploysPerAppPerDay: 20,
    grantsPerApp: 50,
    uploadMaxBytes: 200 * 1024 * 1024,
    envVarsPerApp: 40,
    lambdaReservedConcurrency: 5,
    lambdaMemoryMb: 1024,
    lambdaTimeoutSeconds: 300,
    /** Builder sandboxes (one Fargate task each) are the most expensive thing on the platform. */
    builderSessionsPerStage: 10,
    builderSessionsPerUser: 1,
    builderIdleMinutes: 20,
    builderMaxSessionHours: 6,
    builderTokensPerUserPerDay: 5_000_000,
};
//# sourceMappingURL=quotas.js.map